import React from "react";
import logo from "../../assets/images/WS-logo-for-landing-page-small.png"; // Replace with your logo's path
import heroImage from "../../assets/images/WS-questionnaire-hero.jpg"; // Replace with your hero image's path

const HeroSection = () => {
  return (
    <div className="flex flex-col items-center bg-gray-50">
      <div className="flex flex-col items-center pt-8">
        <img src={logo} alt="WS Logo" className="w-full h-auto" />
      </div>

      {/* Hero Image */}
      <div className="my-8 w-full max-w-3xl">
        <img
          src={heroImage}
          alt="Wedding Ceremony"
          // add rounded-lg only on desktop
          className="w-full md:rounded-lg shadow-md"
        />
      </div>

      {/* Text Below Image */}
      <div className="text-center pb-8">
        <h2 className="text-5xl font-semibold tracking-wider text-black">
          Client Questionnaire
        </h2>
        <p className="text-xl italic text-gray-600">getting to know you</p>
        <p className="mt-4 text-xs text-gray-500 uppercase">
          <a href="https://www.weddings-in-santorini.com/">
          www.weddings-in-santorini.com
          </a>
        </p>
        <p className="text-xs text-gray-500">
          Wedding Planning and Event Management
        </p>
      </div>
    </div>
  );
};

export default HeroSection;
